import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { getContentPage } from "store/actions";

export default function Footer() {
  const dispatch = useDispatch();

  const { settings } = useSelector((state) => state?.Login);
  const { content } = useSelector((state) => state?.contentpage);

  useEffect(() => {
    dispatch(getContentPage());
  }, []);

  return (
    <>
    <section className="footer-main ">
      <Container>
        <div className="fotter_inner">
          <Row>
            <Col lg={4} md={6} sm={12}>
            <div className="logobx mb-4">
                {/* <button className="btn border-0"><i className="fa-sharp fa-light fa-arrow-left-long"></i> Back</button> */}
                <a href="https://terpnash.com/" rel="noreferrer"className="navbar-brand py-0">
                {settings?.logo?.link && (
                  <div className="d-flex align-items-center justify-content-start position-relative gap-3">
                    <>
                      {settings?.logo?.link.search(".mp4") !== -1 ? (
                     
                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            // src={"/images/t3.gif"}
                           alt="logo"
                          />
                      ) : (
                       
                        <img
                          alt="logo"
                          className="img-fluid logodesktop"
                          src={ "/images/svg/logoNewWhite.svg" || "/images/t3.gif"} />
                      )}
                    </>
 {/* <img
                          alt="logo"
                          className="img-fluid logodesktop"
                          src={settings?.logo?.link || "/images/t3.gif"}
                         
                        /> */}
                    {/* <a href="https://terpnash.com/" rel="noreferrer"className="nav-link loginLogo logohead ">
                      Terpnash
                    </a> */}
                  </div>
                )}
              </a>
                </div>
                <p>Where tradition meets innovation, and art transcends boundaries.</p>
                <ul className="social_icon mt-3">
                {settings?.socialMediaSetting?.facebook && (
                    <li>
                      <a rel="noreferrer" className="socialIconn facebookIcon"
                        href={settings?.socialMediaSetting?.facebook}
                        target="_blank"
                      >
                       
                      
                      </a>
                    </li>
                  )}
                  {settings?.socialMediaSetting?.twitter && (
                    <li>
                      <a rel="noreferrer" className="socialIconn twitterIcon"
                        href={settings?.socialMediaSetting?.twitter}
                        target="_blank"
                      >
                        
                      </a>
                    </li>
                  )}
                  <li>
                  <a rel="noreferrer" className="socialIconn LinkedinIcon"
                       href={"https://www.linkedin.com/company/terpnash/"}
                        target="_blank"
                      >
                       
                     
                      </a>
                    
                    </li>
                    {settings?.socialMediaSetting?.youtube && (
                    <li>
                      <a rel="noreferrer"  className="socialIconn youtubeIcon"
                        href={settings?.socialMediaSetting?.youtube}
                        target="_blank"
                      >
                      </a>
                    </li>
                  )}
                {settings?.socialMediaSetting?.instagram && (
                    <li>
                      <a rel="noreferrer" className="socialIconn instagramIcon"
                        href={settings?.socialMediaSetting?.instagram}
                        target="_blank"
                      >
                       
                     
                      </a>
                    </li>
                  )}
                  <li>
                  <a rel="noreferrer" className="socialIconn pintrestIcon"
                        href={'https://www.pinterest.com/terpnashart/'}
                        target="_blank"
                      >
                       
                     
                      </a>
                      
                    </li>
                    <li>
                    <a rel="noreferrer" className="socialIconn discordIcon"
                        href={"https://discord.me/terpnash"}
                        target="_blank"
                      >
                       
                     
                      </a>
                    
                    </li>
                    <li>
                    <a rel="noreferrer" className="socialIconn telegramIcon"
                       href={"https://t.me/+ydVdz82NufUxM2Jl"}
                        target="_blank"
                      >
                       
                     
                      </a>
                     
                    </li>
                 
                
                

                 

                 
                </ul>
              
              {/* <div className="comoon_footer" hidden>
                <h4 className="footer_head">Support</h4>
                <div className="footer_contact">
                  <p>
                    <strong>Address :</strong>
                    {settings?.supportSetting?.address ||
                      "Chandigarh , India.."}
                  </p>

                  {/* <p>
                    <strong>Phone :</strong>
                    {settings?.supportSetting?.mobileNumber || "975198245"}
                  </p> *

                  <p>
                    <strong>Email :</strong>
                    {settings?.supportSetting?.email || "abc@gmail.com"}
                  </p>
                  <p className="mt-2 desktop_copyright d-none d-lg-block">
                    {settings?.footerSetting?.description ||
                      "© 2022 Fine Art Publishing L.L.C."}
                  </p>
                </div>
              </div> */}
            </Col>
            <Col lg={2} className="paddleftFoot" md={6} sm={12}>
              <div className="comoon_footer">
                <h4 className="footer_head">Page</h4>
                <ul className="links_here">
                  {/* <li>
                    <NavLink to="/art-genres">Art Genres</NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink to="/museums">Museums</NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/community">Community</NavLink>
                  </li>
                  <li>
                    <a href="https://shop.thestitchnprintstore.com/terpnash/shop/home" rel="noreferrer noopener" target={"_blank"}>Merch</a>
                  </li>
                  <li>
                    <Link to="/user-faq">User FAQs</Link>
                  </li>
                  <li>
                    <Link to="/artist-faq">Artist FAQs</Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={2} className="paddleftFoot" md={6} sm={12}>
              <div className="comoon_footer">
                <h4 className="footer_head">Legal</h4>
                <ul className="links_here">
                  <li>
                    <Link to="/terms" target={"_blank"}>Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" target={"_blank"}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/nft-purchase_and_IP_license_agreement" target={"_blank"}>Digital Artwork Purchase & IP License Agreement</Link>
                  </li>
                  {/* <li>
                    <Link to="/report">Report Content</Link>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <div className="comoon_footer follow_Links">
                <h4 className="footer_head">Contact Us</h4>
                <ul className="links_here">
                  {/* <li> <i className="fa-light fa-location-dot"></i> <span>
                      3980 N Rio Verde Vista Dr <br />
                      Tucson, Arizona 85750 <br />
                      United States<br />
                      <a className="text-decoration-none" href="tel:520-490-6722">520-490-6722</a></span></li>
                  <li  > */}
                  <li> <i className="fa-light fa-location-dot"></i> <span>
                      PO Box 65975 <br />
                      Tucson, Arizona 85728 <br />
                      United States<br />
                      <a className="text-decoration-none" href="tel:520-490-6722">520-490-6722</a></span></li>
                  <li  >
                  


                  <i className="fa-light fa-envelope"></i>  <div className="d-grid">
                        <a className="text-decoration-none" href={"mailto:info@terpnash.com"}>
                          info@terpnash.com
                        </a>
                        <a className="text-decoration-none" href={"mailto:reports@terpnash.com"}>
                          reports@terpnash.com
                        </a>
                      </div>
                  </li>
                  {/* <li>
                  <i className="fa-light fa-phone"></i> <a rel="noreferrer" href="tel+617693939900"> +61 76939-39900</a>, <a rel="noreferrer" href="tel:+617693939900">+61 76939-39900</a>
                  </li> */}
                </ul>
             
              </div>
            </Col>

          </Row>
        </div>

        {/* <div className="mobile_copyright_wrap d-lg-none">
          <p className="mt-2 mobile_copyright">
            {settings?.footerSetting?.description ||
              "© 2022 Fine Art Publishing L.L.C."}
          </p>
        </div> */}
      </Container>
     
    </section>
    <div className="footerText">Copyright &copy; {new Date().getFullYear()} - All right reserved</div>
    </>
  );
}
